//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Object.js";
import "../no/SIM.js";
import "../no/Session.js";
let d=[[],[[[],"CreateScannerPostBuilder",{R_:{scannerPostBuilder:"SIM.PostConfigurator.ScannerPostBuilder"}},0,0],[[],"CreateCreationPostBuilder",{R_:{creationPostBuilder:"SIM.PostConfigurator.CreationPostBuilder"}},0,0],[["postProcessorFilename"],"CreatePostConfiguratorBuilder",{R_:{postConfiguratorBuilder:"SIM.PostConfigurator.PostConfiguratorBuilder"}},1,0],[[],"CreateUdeBuilder",{R_:{udeBuilder:"SIM.PostConfigurator.UdeBuilder"}},0,0],[[],"CreateUdeParameterBuilder",{R_:{udeParameterBuilder:"SIM.PostConfigurator.UdeParameterBuilder"}},0,0],[[],"CreatePostConfiguratorDebugBuilder",{R_:{postConfiguratorDebugBuilder:"SIM.PostConfigurator.PostConfiguratorDebugBuilder"}},0,0],[["postProcessorFilename"],"CreateEncryptPostprocessorFilesBuilder",{R_:{postConfiguratorBuilder:"SIM.PostConfigurator.EncryptPostprocessorFilesBuilder"}},1,0]],[]];
SPLM.SIM.PostConfigurator.PostConfiguratorManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.SIM.PostConfigurator.PostConfiguratorManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;